import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { LandingPage } from './features/coordinator/pages/LandingPage';
import { AssignmentDetails } from './features/coordinator/pages/AssignmentDetails';
import { AssignmentsList } from './features/coordinator/pages/SessionsList';
import { NewSession } from './features/coordinator/pages/NewSession';
import { SessionDetails } from './features/coordinator/pages/SessionDetails';
import { AddMentor } from './features/coordinator/pages/AddMentor';
import { MentorList } from './features/coordinator/pages/MentorList';
import { AddMentee } from './features/coordinator/pages/AddMentee';
import { MenteeList } from './features/coordinator/pages/MenteeList';
import { NewAssignment } from './features/coordinator/pages/NewAssignment';
import { AuthGuard } from './features/auth/components/AuthGuard';
import { authRoutes } from './features/auth/routes';
import { ScheduledMeetingsList } from './features/coordinator/pages/ScheduledMeetingsList';
import { MeetingDetails } from './features/coordinator/pages/MeetingDetails';
import { Layout } from './features/shared/components/Layout';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* Public routes */}
        {authRoutes}
        
        {/* Protected routes wrapper */}
        <Route element={<AuthGuard />}>
          <Route element={<Layout><Outlet /></Layout>}>
            {/* Default redirect */}
            <Route index element={<Navigate to="/coordinator" replace />} />
            
            {/* Coordinator routes */}
            <Route path="coordinator">
              <Route index element={<LandingPage />} />
              <Route path="assignments" element={<AssignmentsList />} />
              <Route path="assignments/:id" element={<AssignmentDetails />} />
              <Route path="assignments/new" element={<NewAssignment />} />
              <Route path="mentors" element={<MentorList />} />
              <Route path="mentors/add" element={<AddMentor />} />
              <Route path="mentees" element={<MenteeList />} />
              <Route path="mentees/add" element={<AddMentee />} />
              <Route path="meetings" element={<ScheduledMeetingsList />} />
              <Route path="meetings/:uuid" element={<MeetingDetails />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;